'use es6';

export const safe = (callback, fallback = null) => (...args) => {
  try {
    return callback(...args);
  } catch (err) {
    return fallback;
  }
};
export const valid = string => {
  try {
    const json = JSON.parse(string);
    return json !== null && typeof json === 'object';
  } catch (err) {
    return false;
  }
};
export const encode = safe(string => btoa(encodeURIComponent(string)));
export const decode = safe(string => decodeURIComponent(atob(string)));
export const parse = safe(string => JSON.parse(string));
export const stringify = safe(object => JSON.stringify(object, null, 2));
export const sanitize = safe(object => stringify(JSON.parse(object)), '');
export const convertStringToJSObject = safe(jsCodeString =>
// eslint-disable-next-line no-new-func
Function(`return ${jsCodeString}`)(), {});
export const validJSObject = jsCodeString => {
  try {
    // eslint-disable-next-line no-new-func
    const jsObject = Function(`return ${jsCodeString}`)();
    return jsObject !== null && typeof jsObject === 'object';
  } catch (err) {
    return false;
  }
};